import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/blogger/:id',
    name: 'BloggerHome',
    component: () => import('../views/BloggerHome.vue')
  },
  {
    path: '/resource/:id',
    name: 'ResourceDetail',
    component: () => import('../views/ResourceDetail.vue')
  },
  {
    path: '/',
    component: () => import('../views/MainLayout.vue'),
    redirect: '/feed',
    children: [
      {
        path: 'feed',
        name: 'Feed',
        component: () => import('../views/Feed.vue'),
        meta: { tab: 0 }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/Profile.vue'),
        meta: { tab: 1 }
      },
      {
        path: 'orders',
        name: 'MyOrders',
        component: () => import('../views/MyOrders.vue'),
        meta: { tab: 1 }
      },
      {
        path: 'following',
        name: 'Following',
        component: () => import('../views/Following.vue'),
        meta: { tab: 1 }
      }
    ]
  }
];

const router = new VueRouter({ mode: 'hash', routes });

// Pages that don't require auth are: Login, Register, BloggerHome (no tab auth check), ResourceDetail
// For the tab pages inside MainLayout, they are auth-optional for feed (Feed handles its own login prompt)
const noAuthPages = ['Login', 'Register'];

router.beforeEach((to, from, next) => {
  if (!store.state.token && to.name === 'Feed') {
    // Feed page can be viewed without login, but with a prompt
    next();
  } else if (!noAuthPages.includes(to.name) && !store.state.token && to.matched.length > 0) {
    // Other internal pages need auth (orders, following)
    if (to.name === 'MyOrders' || to.name === 'Following') {
      next({ name: 'Login', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
